var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.934 0.716966L6.31732 5.33363C6.00898 5.64197 5.83398 6.06697 5.83398 6.50863V14.8336C5.83398 15.7503 6.58398 16.5003 7.50065 16.5003H15.0007C15.6673 16.5003 16.2673 16.1003 16.534 15.492L19.2507 9.1503C19.9507 7.5003 18.7423 5.66697 16.9507 5.66697H12.2423L13.034 1.8503C13.1173 1.43363 12.9923 1.00863 12.6923 0.708633C12.2007 0.2253 11.4173 0.2253 10.934 0.716966ZM2.50065 16.5003C3.41732 16.5003 4.16732 15.7503 4.16732 14.8336V8.16697C4.16732 7.2503 3.41732 6.5003 2.50065 6.5003C1.58398 6.5003 0.833984 7.2503 0.833984 8.16697V14.8336C0.833984 15.7503 1.58398 16.5003 2.50065 16.5003Z",
    fill: "#009B94"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.fb0a6cd7ff02de3fa70eee8fbb7d540e.svg";
export { ForwardRef as ReactComponent };